import React from "react";
import Modal from "./Modal";
import Icon from "./Icon";

const ReferralCodeModal = ({ show, onClose, email = "" }) => {

  return (
    <Modal show={show} onClose={onClose} title="Claim je gratis ticket" width="400px">
      <div className="text-center">
        <p className="mb-6 text-[16px] text-white leading-[22px]">
          Je bent uitgenodigd om een gratis ticket te claimen! Maak eerst een account aan en claim je gratis ticket.
        </p>

        <div className="flex flex-col gap-3 w-full">
          <button
            onClick={onClose}
            className="bg-gradient-to-r from-[#6A1BD1] hover:from-[#5A0FB1] to-[#7721E5] hover:to-[#6511C5] shadow-md px-[20px] py-[14px] rounded-[8px] w-full font-semibold text-[16px] text-white transition-all duration-200"
          >
            Ik begrijp het
          </button>
        </div>

        <div className="flex justify-center items-center gap-2 mt-4 text-[#B9B6BF] text-[14px]">
          <Icon icon="heroicons:information-circle" className="w-4 h-4" />
          <span>Deze link is 24 uur geldig</span>
        </div>
      </div>
    </Modal>
  );
};

export default ReferralCodeModal;